import { API_ENDPOINT } from "@/constants/appConstants";

import { UserInfoType } from "./saved/types";

export const resolveABVariantAPI = async <T>(abTestBody?: {
  experimentName: string;
  id: string;
}): Promise<T | Error> => {
  try {
    const host = window.location.host;

    const response = await fetch(
      `${API_ENDPOINT(host).middleware.resolveABVariant}`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(abTestBody),
      },
    );

    const data = await response.json();

    return { ...data, status: response.status };
  } catch (error) {
    if (error instanceof Error) {
      throw error;
    } else {
      throw new Error(
        `Error occurred while fetching prepAI questions, ${JSON.stringify(error)}`,
      );
    }
  }
};

export const fetchUserJobInfoAPI = async (
  jobDataIds: (string | undefined)[],
): Promise<UserInfoType> => {
  const userJobInfo = {
    appliedJobIds: [],
    savedJobIds: [],
  };

  if (!jobDataIds?.length) {
    return userJobInfo;
  }

  try {
    const host = window.location.host;
    const response = await fetch(
      `${API_ENDPOINT(host).middleware.getUserJobInfo}`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(jobDataIds),
      },
    );

    if (response.ok) {
      const data = await response.json();
      userJobInfo.appliedJobIds =
        (data &&
          Array.isArray(data) &&
          data
            .filter((job: { applied: boolean }) => job.applied)
            .map((job: { jobId: number }) => String(job.jobId))) ||
        [];

      userJobInfo.savedJobIds =
        (data &&
          Array.isArray(data) &&
          data
            .filter((job: { saved: boolean }) => job.saved)
            .map((job: { jobId: number }) => String(job.jobId))) ||
        [];

      return userJobInfo;
    }

    return userJobInfo;
  } catch (error) {
    if (error instanceof Error) {
      throw error;
    } else {
      throw new Error(
        `Error occurred while fetching data, ${JSON.stringify(error)}`,
      );
    }
  }
};
